import strings from './strings';

function formatEstimatedWaitTime(estimatedWaitMs?: number) {
  // BFF returns placeholder value of 0, and the estimated wait time only
  // gets updated on 'delivered' and 'join' events. So, we should show 'Unavailable'
  // before the queue's estimatedWait is synced with Kazoo value from the events.
  if (estimatedWaitMs === undefined || estimatedWaitMs <= 0) {
    return strings.unavailable;
  }
  const estimatedWaitSecs = estimatedWaitMs / 1000;
  if (estimatedWaitSecs < 60) {
    return strings.lessThanOneMinute;
  }
  const mins = Math.floor(estimatedWaitSecs / 60);
  const seconds = estimatedWaitSecs % 60;
  if (seconds === 0) {
    return strings.minutes(mins);
  }
  return strings.minutesSeconds(mins, seconds);
}

export default formatEstimatedWaitTime;
